import React from 'react';

import cn from 'classnames';

import Carousel from 'components/Carousel';
import StoryListTile from 'components/StoryListTile';

import { StoryTileFragment } from 'graphql/generated/graphql';

import StoriesCarouselSkeleton from './Skeleton';

interface IProps {
  carouselClassName?: string;
  data: ReadonlyArray<StoryTileFragment>;
  endpoint: string;
  matomoTrackingCategory: string;
  loading?: boolean;
}

export const numberOfSkeletonsToShow = 3;
const skeletonPlaceholders = Array.from<StoryTileFragment>({
  length: numberOfSkeletonsToShow,
});

const StoriesCarousel = ({
  carouselClassName,
  data,
  endpoint,
  matomoTrackingCategory,
  loading = false,
}: IProps) => (
  <Carousel
    className={cn('StoriesCarousel', carouselClassName)}
    slidesPerView="auto"
    watchSlidesProgress
  >
    {(loading ? skeletonPlaceholders : data).map((story, index) => {
      if (loading) {
        return <StoriesCarouselSkeleton key={index} />;
      }

      return (
        <StoryListTile
          small
          key={story.id}
          story={story}
          endpoint={endpoint}
          matomoProps={{ name: matomoTrackingCategory }}
          positionInList={index}
        />
      );
    })}
  </Carousel>
);

export default StoriesCarousel;
